/* unplugin-vue-components disabled */import { render } from "./container.vue?vue&type=template&id=e4068faa&scoped=true"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"

import "./container.vue?vue&type=style&index=0&id=e4068faa&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4068faa"]])

export default __exports__